/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import angular from 'angular';

/*---------------------------------------------------------*\
 * photosService
\*---------------------------------------------------------*/
/* @ngInject */
function trafficService(apiService) {
  this.getTrafficDelays = (region) => {
    if (angular.isString(region) && region.length < 3) {
      return apiService.wrap('/api/v1/traffic/incidents/' + region, {});
    }
    return new Error('Invalid Region Code');
  };
  this.getTrafficCameras = (region) => {
    if (angular.isString(region) && region.length < 3) {
      return apiService.wrap('/api/v1/traffic/camera/' + region, {}, 'cameras');
    }
    return new Error('Invalid Region Code');
  };
  this.getTrafficPlaypauseMaps = (region) => {
    if (angular.isString(region) && region.length < 3) {
      return apiService.wrap('/api/v1/traffic/playpause/' + region, {});
    }
    return new Error('Invalid Region Code');
  };
}

trafficService.$inject = [
  'apiService'
];

const api = angular
  .module('trafficService', [])
  .service('trafficService', trafficService);

export default api;



/** WEBPACK FOOTER **
 ** ./client/app/services/apis/trafficService.js
 **/